
// components

import('../components/css-vars/css-vars.js').then(src => src.default());
import('../components/svg-sprite/svg-sprite.js').then(src => src.default());
import('../components/lazy/lazy.js').then(src => src.default());
import('../components/header/header.js').then(src => src.default());
import('../components/seo/seo.js').then(src => src.default());
import('../components/form/ajax/ajax.js').then(src => src.default());
import "../components/form/recaptcha/recaptcha.js";
import('../components/popup/popup.js').then(src => src.default());
import('../components/custom-select/custom-select.js').then(src => src.default());

App.Recaptcha.init();